import Vue from 'vue'
import $axios from 'axios'
import store from '@/store'

export const axios = $axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    transformRequest: [function (data, headers) {
        headers['Authorization'] = `Bearer ${ store.getters['token'] }`
        return JSON.stringify(data)
    }],
    headers: {
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-br',
        'X-Origin': 'payment'
    }
})

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        store.commit('setToken', '')
        window.location = '/error?code=unauthorized_access'
    }else{
        return Promise.reject(error);
    }
});

Vue.prototype.$axios = axios
